<template>
  <div class="imgBox min-w-1400">
    <!-- <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400 fade-in-section">
        <img :src="importedImg1" alt="" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2Box max-w-1400 fade-in-section">
        <img :src="importedImg2" alt="" class="imgItem2" />
      </div>
    </div>
    <div class="imgBox3 min-w-1400">
      <div class="img3Box max-w-1400 fade-in-section">
        <img :src="importedImg3" alt="" class="imgItem3" />
      </div>
    </div>
    <div class="imgBox4 min-w-1400">
      <div class="img4Box max-w-1400 fade-in-section">
        <img :src="importedImg4" alt="" class="imgItem4" />
      </div>
    </div>
    <div class="imgBox5 min-w-1400">
      <div class="img5Box max-w-1400 fade-in-section">
        <img :src="importedImg5" alt="" class="imgItem5" />
      </div>
    </div> -->
    <!-- <div class="imgBox6 min-w-1400">
      <div class="img6Box max-w-1400">
        <img :src="importedImg6" alt="" class="imgItem6" />
      </div>
    </div>
    <div class="imgBox7 min-w-1400">
      <div class="img7Box max-w-1400">
        <img :src="importedImg7" alt="" class="imgItem7" />
      </div>
    </div> -->

    <section class="mini-cards-section py-5" style="">
        
        

        <div class="container position-relative z-index-10">
            <!-- Header -->
            <div class="text-center mb-5">
                <h2 class="display-5 fw-bold mb-3 text-dark">Lavi Finance mang đến cho bạn những chương trình ưu đãi và giảm giá mới nhất!</h2>
                <p class="text-muted lead mx-auto">Tận hưởng cuộc sống trọn vẹn hơn với các gói hỗ trợ tài chính và quà tặng hấp dẫn. Lavi Finance đồng hành cùng bạn để biến mọi dự định thành hiện thực với chi phí tối ưu nhất. Xem chi tiết các tin tức và ưu đãi tại đây.</p>
                <div class="mt-3 mx-auto rounded-pill" style="width: 40px; height: 3px; background: #3b82f6;"></div>
            </div>

            <!-- Grid -->
            <div class="row g-4"  >
                
        <div @click="opneDetail('/vi/khuyen-mai/quet-sach-hoa-don-thanh-toan-khoan-vay-voi-uu-dai-cuc-hoi-len-den-500000-dong')" class="col-lg-4 col-md-6 mb-4">
          <div class="mini-card square-card d-flex flex-column p-3 text-decoration-none h-100">
              <div class="card-img-wrapper mb-3 mx-auto">
                  <img :src="imgImg1" alt="Sử dụng Lavi Finance, tận hưởng ưu đãi lên đến 600.000 VNĐ, trả góp nhẹ nhàng hơn!">
              </div>
              <div class="card-content text-center">
                  <h5 class="fw-bold mb-2 text-dark">Sử dụng Lavi Finance, tận hưởng ưu đãi lên đến 600.000 VNĐ, trả góp nhẹ nhàng hơn!</h5>
                  <p class="text-secondary mb-0">Giảm bớt áp lực thanh toán cuối tháng, giúp tài chính tự do hơn nhờ tính năng trả góp!</p>
                  <br>
                  <br>
              </div>
          </div>
        </div>
      
        <div @click="opneDetail('/vi/khuyen-mai/giai-ngan-tuc-thi-trung-the-cao-het-y-len-toi-500000-dong')" class="col-lg-4 col-md-6 mb-4">
          <div class="mini-card square-card d-flex flex-column p-3 text-decoration-none h-100">
              <div class="card-img-wrapper mb-3 mx-auto">
                  <img :src="imgImg2" alt="Giải ngân ngay - 100% Trúng thẻ nạp điện thoại lên đến 500.000 VNĐ!">
              </div>
              <div class="card-content text-center">
                  <h5 class="fw-bold mb-2 text-dark">Giải ngân ngay - 100% Trúng thẻ nạp điện thoại lên đến 500.000 VNĐ!</h5>
                  <p class="text-secondary mb-0">Từ ngày 15/05 đến 20/06/2026, Lavi Finance chính thức khởi động tuần lễ "Cùng Lavi đón vận may"! </p>
                  <br>
                  <br>
              </div>
          </div>
        </div>
      
        <div @click="opneDetail('/vi/khuyen-mai/mcredit-se-chia-cung-dong-bao-tai-thiet-cuoc-song-voi-chuong-trinh-giam-lai-suat')" class="col-lg-4 col-md-6 mb-4">
          <div class="mini-card square-card d-flex flex-column p-3 text-decoration-none h-100">
              <div class="card-img-wrapper mb-3 mx-auto">
                  <img :src="imgImg3" alt="Lavi Finance khởi động chương trình “Đồng Tâm Hiệp Lực”, giảm lãi suất lên đến 50%, đồng hành tái thiết cuộc sống tốt đẹp hơn!">
              </div>
              <div class="card-content text-center">
                  <h5 class="fw-bold mb-2 text-dark">Lavi Finance khởi động chương trình “Đồng Tâm Hiệp Lực”, giảm lãi suất lên đến 50%, đồng hành tái thiết cuộc sống tốt đẹp hơn!</h5>
                  <p class="text-secondary mb-0">Lavi Finance triển khai “Chương trình ưu đãi giảm lãi suất đặc biệt” dành cho khách hàng ưu chất lượng cao tại các khu vực cụ thể và đáp ứng điều kiện</p>
                  
              </div>
          </div>
        </div>
      
        <div @click="opneDetail('/vi/khuyen-mai/giai-nhiet-he-2025-vay-de-dang-qua-ngap-tran')" class="col-lg-4 col-md-6 mb-4">
          <div class="mini-card square-card d-flex flex-column p-3 text-decoration-none h-100">
              <div class="card-img-wrapper mb-3 mx-auto">
                  <img :src="imgImg4" alt="Chiến dịch Giải nhiệt Mùa hè 2026: Lavi Finance tặng quà cực mát, nhận ưu đãi triệu đồng không ngừng nghỉ!">
              </div>
              <div class="card-content text-center">
                  <h5 class="fw-bold mb-2 text-dark">Chiến dịch Giải nhiệt Mùa hè 2026: Lavi Finance tặng quà cực mát, nhận ưu đãi triệu đồng không ngừng nghỉ!</h5>
                  <p class="text-secondary mb-0">Hãy tận hưởng trọn vẹn bãi biển và những thức uống mát lạnh trong mùa hè này, mọi áp lực tài chính đã có Lavi Finance lo.</p>
                  <br>
                  <br>
              </div>
          </div>
        </div>
      
            </div>
        </div>
      </section>

      <div class="download">
        <section class="download-card max-w-1400 fade-in-section">
          <div class="download-card__media">
            
            <img
              :src="downloadImg"
              alt="AAAA"
              class="download-card__image"
            />
          </div>

          <div class="download-card__content">
            <h2 class="download-card__title">Tải ứng dụng Lavi Finance ngay!</h2>
            <p class="download-card__text">
               Với ứng dụng Lavi Finance, bạn có thể dễ dàng đăng ký khoản vay lên đến 30.000.000 VNĐ, quản lý hóa đơn mọi lúc mọi nơi và tận hưởng dịch vụ tài chính an toàn, minh bạch.
            </p>
            <!-- <p class="download-card__text">
              aaaa aaaa aaaa aaaa aaaa aaaa.
            </p> -->
            <a href="https://apps.apple.com/vn/app/lavi-finance/id6741784212" target="_blank" type="button" class="download-card__button">Tải ứng dụng ngay</a>
          </div>
        </section>
      </div>
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/lavifinancecompany/components/img/2_1.png";
import importedImg2 from "@/page/lavifinancecompany/components/img/2_2.png";
import importedImg3 from "@/page/lavifinancecompany/components/img/2_3.png";
import importedImg4 from "@/page/lavifinancecompany/components/img/2_4.png";
import importedImg5 from "@/page/lavifinancecompany/components/img/2_5.png";
import appPreviewImg from "@/page/lavifinancecompany/components/img/app-1.jpg";
import downloadImg from "@/page/lavifinancecompany/components/img/download.png";
import imgImg1 from "@/page/lavifinancecompany/components/img/img-1.png";
import imgImg2 from "@/page/lavifinancecompany/components/img/img-2.png";
import imgImg3 from "@/page/lavifinancecompany/components/img/img-3.png";
import imgImg4 from "@/page/lavifinancecompany/components/img/img-4.png";
// import importedImg6 from "@/page/lavifinancecompany/components/img/2_6.png";
// import importedImg7 from "@/page/lavifinancecompany/components/img/2_7.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      importedImg5: importedImg5,
      appPreviewImg: appPreviewImg,
      downloadImg: downloadImg,
      imgImg1: imgImg1,
      imgImg2: imgImg2,
      imgImg3: imgImg3,
      imgImg4: imgImg4,
      // importedImg6: importedImg6,
      // importedImg7: importedImg7,
      altText: "图片",
    };
  },
  mounted() {
    this.InitPage();

    
  },
  methods: {
    opneDetail(address){
      window.open(`https://www.lavifinance.com${address}`, '_blank');
    },
    InitPage(){
      window.scrollTo({ top: 0 });
      const fadeInSections = document.querySelectorAll('.fade-in-section');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
      });
    }, {
        threshold: 0.3
    });
      fadeInSections.forEach(section => {
          observer.observe(section);
      });
    }
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}
img {
  display: block;
}
.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6,
.imgBox7 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
      min-height: 400px;
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box,
.img7Box {
  margin: 0;
  overflow: hidden;
  width: 100%;
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7 {
  width: 100%;
  margin: 0;
}


.img2Box,
.img4Box{
  padding:  0 220px;
}
.img2Box,
.img4Box{
  margin: 90px 0;
}


        /* Style 2 Preview Fix */
        

        .mini-cards-section {
            position: relative;
        }

        .section-immersive {
            background-size: cover;
            background-position: center;
            background-attachment: fixed;
        }

        .section-overlay {
            position: absolute;
            top: 0; left: 0; width: 100%; height: 100%;
            background: linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0.8) 100%);
            z-index: 1;
        }

        .z-index-10 { position: relative; z-index: 10; }

        .mini-card {
            background: #fff;
            border: 1px solid rgba(0,0,0,0.06);
            border-radius: 16px;
            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
            position: relative;
            z-index: 1;
            box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05);
        }

        /* Immersive Glassmorphism Styles */
        .section-immersive .mini-card {
            background: rgba(255, 255, 255, 0.08);
            backdrop-filter: blur(12px);
            -webkit-backdrop-filter: blur(12px);
            border: 1px solid rgba(255, 255, 255, 0.15);
            box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.2);
        }

        .mini-card:hover {
            transform: translateY(-5px);
            border-color: #3b82f640;
            box-shadow: 0 15px 30px -10px rgba(0,0,0,0.08);
        }

        .section-immersive .mini-card:hover {
            background: rgba(255, 255, 255, 0.12);
            border-color: rgba(255, 255, 255, 0.3);
            box-shadow: 0 15px 40px -10px rgba(0,0,0,0.4);
        }

        /* Image Wrapper Logic */
        .card-img-wrapper {
            overflow: hidden;
            position: relative;
            background: #f1f5f9;
        }
        .card-img-wrapper img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.5s ease;
        }
        .mini-card:hover img {
            transform: scale(1.1);
        }

        /* Style Specifics */
        .square-card .card-img-wrapper {
            width: 100%;
            aspect-ratio: 16 / 10;
            border-radius: 12px;
        }

        .circle-card .card-img-wrapper {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            border: 3px solid #fff;
            box-shadow: 0 4px 10px rgba(0,0,0,0.05);
        }

        .horizontal-card .card-img-wrapper {
            width: 100px;
            height: 80px;
            border-radius: 10px;
        }

        /* Text Utilities */
        .text-truncate-2 {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
        
        .tracking-widest { letter-spacing: 2px; }

        @media (max-width: 768px) {
            .horizontal-card { flex-direction: row !important; }
        }

.download {
  display: flex;
  justify-content: center;
  padding: 24px 0 80px;
}

.download-card {
  display: grid;
  grid-template-columns: minmax(420px, 0.95fr) minmax(360px, 1fr);
  gap: 46px;
  width: 100%;
  padding: 28px 30px;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.05);
  border-radius: 32px;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.download-card__media {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  min-height: 520px;
  padding: 28px 20px 0;
  background: linear-gradient(180deg, #fff8f6 0%, #fff1ec 100%);
  border-radius: 26px;
  overflow: hidden;
}

.download-card__media-backdrop {
  position: absolute;
  left: 9%;
  right: 9%;
  bottom: -30px;
  height: 68%;
  background: linear-gradient(180deg, #ffd9cb 0%, #ffc7b2 100%);
  border-radius: 40px 40px 0 0;
}

.download-card__media-backdrop::before {
  position: absolute;
  top: 56px;
  left: -38px;
  width: 180px;
  height: 180px;
  content: "";
  border: 1px solid rgba(143, 89, 65, 0.15);
  border-radius: 50%;
}

.download-card__media-backdrop::after {
  position: absolute;
  top: 108px;
  left: 36px;
  width: 10px;
  height: 10px;
  content: "";
  background: #ffb48a;
  border-radius: 50%;
  box-shadow: 18px 24px 0 rgba(255, 180, 138, 0.55);
}

.download-card__image {
  position: relative;
  z-index: 1;
  width: 100%;
  max-height: 560px;
  object-fit: contain;
  object-position: center bottom;
  filter: drop-shadow(0 24px 34px rgba(0, 0, 0, 0.16));
}

.download-card__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 10px 18px 10px 0;
}

.download-card__title {
  margin: 0 0 20px;
  color: #111827;
  font-size: 58px;
  font-weight: 800;
  line-height: 1.08;
}

.download-card__text {
  margin: 0 0 16px;
  max-width: 680px;
  color: #4b5563;
  font-size: 21px;
  line-height: 1.75;
}

.download-card__button {
  margin-top: 16px;
  padding: 18px 38px;
  border: none;
  border-radius: 999px;
  color: #ffffff;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
  background: linear-gradient(135deg, #5a6ef4 0%, #202ecf 100%);
  box-shadow: 0 18px 34px rgba(239, 35, 60, 0.22);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.download-card__button:hover {
  transform: translateY(-2px);
  box-shadow: 0 22px 40px rgba(239, 35, 60, 0.28);
}

@media (max-width: 1200px) {
  .download-card {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .download-card__content {
    padding-right: 0;
  }
}

@media (max-width: 768px) {
  .download {
    padding-bottom: 56px;
  }

  .download-card {
    padding: 18px;
    border-radius: 24px;
  }

  .download-card__media {
    min-height: 420px;
  }

  .download-card__title {
    font-size: 40px;
  }

  .download-card__text {
    font-size: 18px;
  }

  .download-card__button {
    font-size: 20px;
    padding: 16px 30px;
  }
}
</style>
